import { render, staticRenderFns } from "./DeletePortfolioModal.vue?vue&type=template&id=ec631f1e&"
import script from "./DeletePortfolioModal.vue?vue&type=script&lang=ts&"
export * from "./DeletePortfolioModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports